module.exports = __webpack_public_path__ + "static/media/analytics.1f47d347.svg";